import { supabase } from '../lib/supabase';
import { DocumentoModelo, TipoDocumentoModelo } from '../types/documentoModelo';

const LOCAL_STORAGE_KEY = 'voope_modelos_documento_v3';

// Helper to construct canvas objects easily
const PAGE_1_PROPOSTA_OBJECTS = [
  // Top Header Banner Dark
  {
    type: 'rect',
    left: 0,
    top: 0,
    width: 794,
    height: 115,
    fill: '#0f172a'
  },
  {
    type: 'rect',
    left: 0,
    top: 111,
    width: 794,
    height: 4,
    fill: '#dc2626'
  },
  {
    type: 'i-text',
    left: 50,
    top: 32,
    text: 'PROPOSTA COMERCIAL',
    fontSize: 24,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 50,
    top: 65,
    text: 'VOOPE LOGÍSTICA & SOLUÇÕES EM TRANSPORTE',
    fontSize: 11,
    fill: '#94a3b8',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 530,
    top: 38,
    text: 'REF: {{PROPOSTA_REF}}',
    fontSize: 11,
    fontWeight: 'bold',
    fill: '#f8fafc',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 530,
    top: 58,
    text: 'Emissão: {{DATA_EMISSAO}}',
    fontSize: 10,
    fill: '#cbd5e1',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 530,
    top: 76,
    text: 'Validade: {{VALIDADE_PROPOSTA}}',
    fontSize: 10,
    fill: '#cbd5e1',
    fontFamily: 'Arial'
  },

  // Cliente Box
  {
    type: 'rect',
    left: 50,
    top: 145,
    width: 694,
    height: 85,
    fill: '#f8fafc',
    stroke: '#cbd5e1',
    strokeWidth: 1,
    rx: 8,
    ry: 8
  },
  {
    type: 'i-text',
    left: 70,
    top: 158,
    text: 'APRESENTADO A:',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#dc2626',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 70,
    top: 176,
    text: '{{CLIENTE_NOME}}',
    fontSize: 14,
    fontWeight: 'bold',
    fill: '#0f172a',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 70,
    top: 200,
    text: 'A/C: {{SOLICITANTE}} • Email: {{CLIENTE_EMAIL}} • Tel: {{CLIENTE_TELEFONE}}',
    fontSize: 10,
    fill: '#475569',
    fontFamily: 'Arial'
  },

  // Intro
  {
    type: 'i-text',
    left: 50,
    top: 250,
    text: 'Prezados,',
    fontSize: 12,
    fontWeight: 'bold',
    fill: '#0f172a',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 50,
    top: 275,
    text: 'A VOOPE Logística apresenta sua proposta comercial para prestação de serviços de transporte e soluções dedicadas,\ngarantindo alta eficiência operacional, veículos rastreados e pontualidade na rota.',
    fontSize: 11,
    fill: '#334155',
    fontFamily: 'Arial'
  },

  // Tabela de Valores
  {
    type: 'rect',
    left: 50,
    top: 340,
    width: 694,
    height: 28,
    fill: '#1e293b',
    rx: 4,
    ry: 4
  },
  {
    type: 'i-text',
    left: 65,
    top: 348,
    text: 'DESCRIÇÃO DOS SERVIÇOS DE TRANSPORTE',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 450,
    top: 348,
    text: 'QTD',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 580,
    top: 348,
    text: 'INVESTIMENTO',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },

  // Tabela dinâmica: gera uma linha por item da proposta.
  // Mova/redimensione este campo no editor para definir a área da tabela.
  {
    type: 'i-text',
    left: 65,
    top: 378,
    width: 664,
    text: '{{TABELA_ITENS}}',
    fontSize: 11,
    fill: '#334155',
    fontFamily: 'Arial'
  },

  // Total Box
  {
    type: 'rect',
    left: 440,
    top: 475,
    width: 304,
    height: 52,
    fill: '#fef2f2',
    stroke: '#fca5a5',
    strokeWidth: 1,
    rx: 6,
    ry: 6
  },
  {
    type: 'i-text',
    left: 455,
    top: 492,
    text: 'VALOR TOTAL:',
    fontSize: 11,
    fontWeight: 'bold',
    fill: '#991b1b',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 565,
    top: 489,
    text: 'R$ {{VALOR_TOTAL}}',
    fontSize: 15,
    fontWeight: 'bold',
    fill: '#dc2626',
    fontFamily: 'Arial'
  },

  // Condições
  {
    type: 'i-text',
    left: 50,
    top: 555,
    text: 'CONDIÇÕES COMERCIAIS & OPERACIONAIS:',
    fontSize: 11,
    fontWeight: 'bold',
    fill: '#1e293b',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 50,
    top: 580,
    text: '• Validade desta proposta: {{VALIDADE_PROPOSTA}} a contar da data de emissão.\n• Forma de Pagamento: {{FORMA_PAGAMENTO}}.\n• Seguro de Carga: Modalidade RCTR-C inclusa em todos os trechos operados.\n• Rastreamento: Monitoramento em tempo real via sistema VOOPE.',
    fontSize: 10,
    fill: '#475569',
    fontFamily: 'Arial'
  },

  // Footer continuation note
  {
    type: 'rect',
    left: 50,
    top: 1040,
    width: 694,
    height: 30,
    fill: '#f1f5f9',
    rx: 4,
    ry: 4
  },
  {
    type: 'i-text',
    left: 65,
    top: 1048,
    text: 'PÁGINA 1 DE 2 • ESPECIFICAÇÕES TÉCNICAS E ACEITE NA PÁGINA SEGUINTE →',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#64748b',
    fontFamily: 'Arial'
  }
];

const PAGE_2_PROPOSTA_OBJECTS = [
  // Top Banner Page 2
  {
    type: 'rect',
    left: 0,
    top: 0,
    width: 794,
    height: 60,
    fill: '#0f172a'
  },
  {
    type: 'rect',
    left: 0,
    top: 56,
    width: 794,
    height: 4,
    fill: '#dc2626'
  },
  {
    type: 'i-text',
    left: 50,
    top: 20,
    text: 'PROPOSTA COMERCIAL — ESPECIFICAÇÕES E ACEITE',
    fontSize: 14,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 580,
    top: 22,
    text: 'REF: {{PROPOSTA_REF}}',
    fontSize: 11,
    fontWeight: 'bold',
    fill: '#94a3b8',
    fontFamily: 'Arial'
  },

  // Section 1: Frota de Veículos
  {
    type: 'rect',
    left: 50,
    top: 85,
    width: 694,
    height: 24,
    fill: '#1e293b',
    rx: 4,
    ry: 4
  },
  {
    type: 'i-text',
    left: 65,
    top: 90,
    text: '1. ESPECIFICAÇÕES DA FROTA E CAPACIDADES',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },
  {
    type: 'rect',
    left: 50,
    top: 113,
    width: 694,
    height: 100,
    fill: '#ffffff',
    stroke: '#cbd5e1',
    strokeWidth: 1,
    rx: 6,
    ry: 6
  },
  {
    type: 'i-text',
    left: 65,
    top: 125,
    text: '• Veículo VUC (Veículo Urbano de Carga): Capacidade até 3.500 kg / Baú Sider ou Refrigerado.\n• Caminhão Toco (16T) e Truck (23T): Operações dedicadas regionais e intermunicipais.\n• Utilitários e HR/Fiorino: Entregas expressas urbanas com agilidade em áreas restritas.',
    fontSize: 10,
    fill: '#334155',
    fontFamily: 'Arial'
  },

  // Section 2: Gerenciamento de Risco
  {
    type: 'rect',
    left: 50,
    top: 235,
    width: 694,
    height: 24,
    fill: '#1e293b',
    rx: 4,
    ry: 4
  },
  {
    type: 'i-text',
    left: 65,
    top: 240,
    text: '2. GERENCIAMENTO DE RISCO, SEGUROS E RASTREAMENTO',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },
  {
    type: 'rect',
    left: 50,
    top: 263,
    width: 694,
    height: 100,
    fill: '#ffffff',
    stroke: '#cbd5e1',
    strokeWidth: 1,
    rx: 6,
    ry: 6
  },
  {
    type: 'i-text',
    left: 65,
    top: 275,
    text: '• Cobertura de Seguro: Apólice RCTR-C ativa com cobertura total de acidentes e roubo.\n• Monitoramento Telemetria: Rastreamento em tempo real via satélite e GPS VOOPE.\n• Controle de Motoristas: Equipe 100% checada com cadastro homologado e treinamento em GR.',
    fontSize: 10,
    fill: '#334155',
    fontFamily: 'Arial'
  },

  // Section 3: SLA
  {
    type: 'rect',
    left: 50,
    top: 385,
    width: 694,
    height: 24,
    fill: '#1e293b',
    rx: 4,
    ry: 4
  },
  {
    type: 'i-text',
    left: 65,
    top: 390,
    text: '3. SLA DE ATENDIMENTO E COMPROMISSOS',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#ffffff',
    fontFamily: 'Arial'
  },
  {
    type: 'rect',
    left: 50,
    top: 413,
    width: 694,
    height: 90,
    fill: '#ffffff',
    stroke: '#cbd5e1',
    strokeWidth: 1,
    rx: 6,
    ry: 6
  },
  {
    type: 'i-text',
    left: 65,
    top: 425,
    text: '• Tempo de Resposta para Disponibilização de Veículo: Até 2 horas após confirmação.\n• Canhoto de Entrega Digitalizado: Disponível em até 24h no portal VOOPE.\n• Relatórios Operacionais Mensais com KPI de Pontualidade e Entregas.',
    fontSize: 10,
    fill: '#334155',
    fontFamily: 'Arial'
  },

  // Termo de Aceite & Signatures Box
  {
    type: 'rect',
    left: 50,
    top: 525,
    width: 694,
    height: 250,
    fill: '#f8fafc',
    stroke: '#cbd5e1',
    strokeWidth: 1,
    rx: 8,
    ry: 8
  },
  {
    type: 'i-text',
    left: 70,
    top: 540,
    text: '4. TERMO DE ACEITE E APROVAÇÃO DA PROPOSTA',
    fontSize: 11,
    fontWeight: 'bold',
    fill: '#dc2626',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 70,
    top: 565,
    text: 'Ao assinar este documento, o cliente concorda expressamente com todos os valores, condições de pagamento\ne prazos descritos nesta proposta comercial nº {{PROPOSTA_REF}}.',
    fontSize: 10,
    fill: '#475569',
    fontFamily: 'Arial'
  },

  // Signatures Lines
  {
    type: 'line',
    x1: 80,
    y1: 690,
    x2: 340,
    y2: 690,
    stroke: '#64748b',
    strokeWidth: 1
  },
  {
    type: 'i-text',
    left: 125,
    top: 698,
    text: 'VOOPE Logística e Transportes',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#334155',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 140,
    top: 715,
    text: 'Departamento Comercial',
    fontSize: 9,
    fill: '#64748b',
    fontFamily: 'Arial'
  },

  {
    type: 'line',
    x1: 450,
    y1: 690,
    x2: 710,
    y2: 690,
    stroke: '#64748b',
    strokeWidth: 1
  },
  {
    type: 'i-text',
    left: 515,
    top: 698,
    text: 'Aceite do Cliente',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#334155',
    fontFamily: 'Arial'
  },
  {
    type: 'i-text',
    left: 450,
    top: 718,
    text: 'Nome: ___________________________________\nCargo: __________________ Data: ____/____/____',
    fontSize: 9,
    fill: '#64748b',
    fontFamily: 'Arial'
  },

  // Footer Page 2
  {
    type: 'i-text',
    left: 310,
    top: 1060,
    text: 'PÁGINA 2 DE 2 • VOOPE LOGÍSTICA',
    fontSize: 10,
    fontWeight: 'bold',
    fill: '#94a3b8',
    fontFamily: 'Arial'
  }
];

const PAGE_1_OS_OBJECTS = [
  // Header Logo Left
  { type: 'i-text', left: 50, top: 35, text: 'V', fontSize: 38, fontWeight: 'bold', fill: '#dc2626', fontFamily: 'Arial' },
  { type: 'i-text', left: 78, top: 40, text: 'VOOPE', fontSize: 22, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 78, top: 62, text: 'TRANSPORTE E CARGAS', fontSize: 8, fontWeight: 'bold', fill: '#475569', fontFamily: 'Arial' },

  // Header Right Contact Info
  { type: 'i-text', left: 510, top: 35, text: 'VOOPE TRANSPORTES', fontSize: 13, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 470, top: 58, text: 'TELEFONE: (11) 9 - 4711-5843', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 500, top: 76, text: 'comercial@voopetrans.com.br', fontSize: 11, fontWeight: 'bold', fill: '#2563eb', fontFamily: 'Arial' },

  // Top Line Separator
  { type: 'line', x1: 50, y1: 102, x2: 744, y2: 102, stroke: '#334155', strokeWidth: 2 },

  // Title Line
  { type: 'i-text', left: 190, top: 115, text: 'Ordem de Serviço: {{NUMERO_OS}} - Data: {{DATA_EMISSAO}}', fontSize: 13, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'line', x1: 50, y1: 140, x2: 744, y2: 140, stroke: '#94a3b8', strokeWidth: 1 },

  // Cliente Info
  { type: 'i-text', left: 50, top: 152, text: 'Cliente: {{CLIENTE_NOME}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 172, text: 'E-mail: {{CLIENTE_EMAIL}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 192, text: 'Telefone: {{CLIENTE_TELEFONE}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'line', x1: 50, y1: 216, x2: 744, y2: 216, stroke: '#94a3b8', strokeWidth: 1 },

  // Veiculo & Ajudante
  { type: 'i-text', left: 50, top: 228, text: 'Veiculo Solicitado: {{VEICULO_TIPO}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 248, text: 'Valor: R$ {{VALOR_FRETE}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 268, text: 'Ajudante: {{AJUDANTE_NOME}}    Valor: R$ {{VALOR_AJUDANTE}}    Quantidade: {{QTD_AJUDANTE}}    Sub Total: R$ {{SUBTOTAL_AJUDANTE}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'line', x1: 50, y1: 292, x2: 744, y2: 292, stroke: '#94a3b8', strokeWidth: 1 },

  // Horarios
  { type: 'i-text', left: 50, top: 320, text: 'Hora Inicial: {{HORA_INICIAL}}    Hora Final: {{HORA_FINAL}}    Total de Horas: {{TOTAL_HORAS}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },

  // Endereco Retirada
  { type: 'i-text', left: 50, top: 360, text: 'Endereço de Retirada:', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 380, text: '{{ENDERECO_COLETA}}', fontSize: 11, fill: '#0f172a', fontFamily: 'Arial' },

  // Endereco Entrega
  { type: 'i-text', left: 50, top: 420, text: 'Endereço de Entrega:', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 440, text: '{{ENDERECO_ENTREGA}}', fontSize: 11, fill: '#0f172a', fontFamily: 'Arial' },

  // Descricao Servicos
  { type: 'i-text', left: 50, top: 480, text: 'Descrição Dos Serviços:', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 500, text: '{{SERVICO_DESCRICAO}}', fontSize: 11, fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'line', x1: 50, y1: 528, x2: 744, y2: 528, stroke: '#94a3b8', strokeWidth: 1 },

  // Motorista & Placa
  { type: 'i-text', left: 50, top: 540, text: 'Motorista: {{MOTORISTA_NOME}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 450, top: 540, text: 'Documento: {{MOTORISTA_DOCUMENTO}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 50, top: 565, text: 'Placa: {{VEICULO_PLACA}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'line', x1: 50, y1: 590, x2: 744, y2: 590, stroke: '#94a3b8', strokeWidth: 1 },

  // Valor Total
  { type: 'i-text', left: 50, top: 615, text: 'Valor Total O.S: R$ {{VALOR_TOTAL}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'line', x1: 50, y1: 640, x2: 744, y2: 640, stroke: '#94a3b8', strokeWidth: 1 },

  // Assinatura
  { type: 'i-text', left: 50, top: 655, text: 'Assinatura:', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'image', left: 50, top: 675, width: 260, height: 60, src: '{{ASSINATURA}}' },
  { type: 'line', x1: 50, y1: 680, x2: 744, y2: 680, stroke: '#94a3b8', strokeWidth: 1 },

  // RG / IP
  { type: 'i-text', left: 370, top: 695, text: 'RG: {{RG_ASSINATURA}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
  { type: 'i-text', left: 375, top: 715, text: 'IP: {{IP_ASSINATURA}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },

  // Footer validation text
  { type: 'i-text', left: 260, top: 760, text: '{{VALIDACAO_DIGITAL}}', fontSize: 11, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' }
];

// Initial default templates if none exist
export const DEFAULT_MODELOS: DocumentoModelo[] = [
  {
    id: 'modelo-default-os-1',
    nome: 'Modelo Padrão - Ordem de Serviço VOOPE',
    tipo: 'ordem_servico',
    descricao: 'Modelo oficial impresso de Ordem de Serviço VOOPE Transportes',
    versao: 6,
    ativo: true,
    padrao: true,
    largura_px: 794,
    altura_px: 1123,
    paginas_count: 1,
    canvas_json: JSON.stringify({
      version: '5.3.0',
      paginas_count: 1,
      pages: [
        JSON.stringify({
          version: '5.3.0',
          objects: PAGE_1_OS_OBJECTS
        })
      ]
    }),
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },

  {
    id: 'modelo-default-proposta-1',
    nome: 'Modelo Padrão - Proposta Comercial VOOPE (2 Páginas)',
    tipo: 'proposta',
    descricao: 'Modelo executivo multi-página para apresentação de propostas comerciais completas',
    versao: 5,
    ativo: true,
    padrao: true,
    largura_px: 794,
    altura_px: 1123,
    paginas_count: 2,
    canvas_json: JSON.stringify({
      version: '5.3.0',
      paginas_count: 2,
      pages: [
        JSON.stringify({ version: '5.3.0', objects: PAGE_1_PROPOSTA_OBJECTS }),
        JSON.stringify({ version: '5.3.0', objects: PAGE_2_PROPOSTA_OBJECTS })
      ]
    }),
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];

export const modeloDocumentoService = {
  /**
   * List all document templates, ensuring default models exist and are updated
   */
  async getModelos(): Promise<DocumentoModelo[]> {
    let modelos: DocumentoModelo[] = [];

    try {
      const { data, error } = await supabase
        .from('documento_modelo')
        .select('*')
        .order('created_at', { ascending: false });

      if (!error && data && data.length > 0) {
        modelos = data as DocumentoModelo[];
      }
    } catch (err) {
      console.warn('Tabela documento_modelo ausente no Supabase, utilizando armazenamento local:', err);
    }

    if (modelos.length === 0) {
      const local = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (local) {
        try {
          modelos = JSON.parse(local);
        } catch (e) {
          console.error('Error parsing local storage modelos:', e);
        }
      }
    }

    // Force updates if defaults are missing or outdated
    let updated = false;
    DEFAULT_MODELOS.forEach((def) => {
      const idx = modelos.findIndex((m) => m.id === def.id || m.nome === def.nome);
      if (idx === -1) {
        modelos.unshift(def);
        updated = true;
      } else {
        // Upgrade if stored default model is version < 3 or lacks multi-page pages array
        if ((modelos[idx].versao || 1) < def.versao) {
          modelos[idx] = { ...def };
          updated = true;
        }
      }
    });

    if (updated || !localStorage.getItem(LOCAL_STORAGE_KEY)) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(modelos));
    }

    return modelos;
  },

  /**
   * Restore/Reset default templates to official prefilled state
   */
  async restaurarModelosPadrao(): Promise<DocumentoModelo[]> {
    const existentes = await this.getModelos();
    const idsPadrao = DEFAULT_MODELOS.map((d) => d.id);
    
    // Remove existing defaults from list and re-add updated DEFAULT_MODELOS
    const customizadas = existentes.filter((m) => !idsPadrao.includes(m.id));
    const finalLista = [...DEFAULT_MODELOS, ...customizadas];

    for (const def of DEFAULT_MODELOS) {
      try {
        await supabase.from('documento_modelo').upsert(def);
      } catch (e) {
        // ignore
      }
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(finalLista));
    return finalLista;
  },

  /**
   * Save or update a model
   */
  async salvarModelo(modelo: Partial<DocumentoModelo> & { nome: string; tipo: TipoDocumentoModelo }): Promise<DocumentoModelo> {
    const now = new Date().toISOString();

    const payload: DocumentoModelo = {
      id: modelo.id || `modelo-${Date.now()}`,
      nome: modelo.nome,
      tipo: modelo.tipo,
      descricao: modelo.descricao || '',
      versao: modelo.versao || 1,
      ativo: modelo.ativo ?? true,
      padrao: modelo.padrao ?? false,
      largura_px: modelo.largura_px || 794,
      altura_px: modelo.altura_px || 1123,
      paginas_count: modelo.paginas_count || 1,
      canvas_json: modelo.canvas_json || JSON.stringify({ version: '5.3.0', objects: [] }),
      created_at: modelo.created_at || now,
      updated_at: now
    };

    try {
      const { data, error } = await supabase
        .from('documento_modelo')
        .upsert(payload)
        .select()
        .single();

      if (!error && data) {
        await this.syncLocalStorage(payload);
        return data as DocumentoModelo;
      }
    } catch (e) {
      console.warn('Erro ao salvar no Supabase, salvando localmente:', e);
    }

    await this.syncLocalStorage(payload);
    return payload;
  },

  /**
   * Duplicate a model
   */
  async duplicarModelo(id: string): Promise<DocumentoModelo | null> {
    const modelos = await this.getModelos();
    const original = modelos.find(m => m.id === id);
    if (!original) return null;

    const copia: Partial<DocumentoModelo> = {
      ...original,
      id: `modelo-${Date.now()}`,
      nome: `${original.nome} (Cópia)`,
      versao: 1,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    };

    delete copia.id;
    return this.salvarModelo(copia as any);
  },

  /**
   * Delete a model
   */
  async excluirModelo(id: string): Promise<boolean> {
    const { error } = await supabase.from('documento_modelo').delete().eq('id', id);

    // Código 42P01 = tabela não existe no Supabase (uso 100% local, esperado).
    // Qualquer outro erro (permissão, RLS, rede) NÃO deve seguir como se tivesse
    // funcionado — senão o modelo "some" só no navegador atual e reaparece
    // intacto para qualquer outro usuário/dispositivo.
    if (error && error.code !== '42P01') {
      console.error('Erro ao excluir modelo no Supabase:', error);
      return false;
    }

    const modelos = await this.getModelos();
    const filtrados = modelos.filter(m => m.id !== id);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(filtrados));
    return true;
  },

  /**
   * Define qual modelo é o oficial do tipo (o usado ao gerar OS/Proposta).
   * Só um modelo por tipo fica marcado como padrão.
   */
  async definirComoPadrao(id: string): Promise<boolean> {
    const modelos = await this.getModelos();
    const alvo = modelos.find((m) => m.id === id);
    if (!alvo) return false;

    const doMesmoTipo = modelos.filter((m) => m.tipo === alvo.tipo);

    for (const modelo of doMesmoTipo) {
      const devePadrao = modelo.id === id;
      if (!!modelo.padrao === devePadrao) continue;
      await this.salvarModelo({
        ...modelo,
        padrao: devePadrao,
        // marcar como padrão implica estar ativo
        ativo: devePadrao ? true : modelo.ativo,
      });
    }

    return true;
  },

  /**
   * Synchronize payload into LocalStorage
   */
  async syncLocalStorage(modelo: DocumentoModelo): Promise<void> {
    const modelos = await this.getModelos();
    const idx = modelos.findIndex(m => m.id === modelo.id);
    if (idx >= 0) {
      modelos[idx] = modelo;
    } else {
      modelos.unshift(modelo);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(modelos));
  }
};
